<section class="rms-pulldown"
         cdkDrag cdkDragRootElement=".cdk-overlay-pane"
         cdkDragBoundary=".cdk-overlay-container"
         [cdkDragDisabled]="!movable"
         [@pulldown]="animState"
         (@pulldown.done)="onAnimDone($event)">
  <div class="rms-pulldown__header" cdkDragHandle [class.movable]="movable">
    <span class="rms-pulldown__title">{{ data?.title || ' ' }}</span>
    <button mat-icon-button class="rms-pulldown__close" aria-label="Close panel" [disabled]="!ref.canClose()" (click)="requestClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="rms-pulldown__body">
    <ng-template cdkPortalOutlet></ng-template>
  </div>
</section>
